import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BillersformComponent } from './billers-list/billersform/billersform.component';
import { BillerslistComponent } from './billers-list/billerslist/billerslist.component';
import { CategoryFormComponent } from './category/category-form/category-form.component';
import { CategoryListComponent } from './category/category-list/category-list.component';
import { ServicetypeformComponent } from './serviceType/servicetypeform/servicetypeform.component';
import { ServicetypelistComponent } from './serviceType/servicetypelist/servicetypelist.component';
import { FeescategoryComponent } from './feescategory/feescategory.component';

const routes: Routes = [
  { path: 'efcategoriesList', component: CategoryListComponent },
  { path: 'efcategoriesForm/:id', component: CategoryFormComponent },
  { path: 'efbillerslist', component: BillerslistComponent },
  { path: 'efbillersform/:id', component: BillersformComponent },
  { path: 'efbillersservicetypelist', component: ServicetypelistComponent },
  { path: 'efbillersservicetypeform/:id', component: ServicetypeformComponent },
  { path: 'effeescategory', component: FeescategoryComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EFawateercomRoutingModule { }
